import {BuyBonusButtonViewLandscape} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusButton/BuyBonusButtonViewLandscape';
import {KeypadView} from '@gongxigames/framework/slot/modules/keypad/KeypadView';
import {KeypadViewMobilePortrait} from '@gongxigames/framework/slot/modules/keypad/KeypadViewMobilePortrait';
import {Sprite} from 'pixi.js';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {DeviceType} from '@gongxigames/framework/core';

export class BuyBonusButtonViewPortrait extends BuyBonusButtonViewLandscape {
    public static readonly NAME: symbol = Symbol('BuyBonusButtonViewPortrait');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobilePortrait.NAME).mainSprite;
    }
}
